export default "__VITE_ASSET__Cs6TzLTA__"